import { useQuery } from "@tanstack/react-query";
import { getOutlets } from "../services/outlet";

export function useOutlets(options = {}) {

    return useQuery({

        queryKey: ["outlets"],

        queryFn: getOutlets,

        staleTime: 1000 * 60 * 5,

        ...options,

    });

}